import { colorsPalettes } from "@similarweb/styles";

import { NO_DATA_SIGN } from "app/filters/const";
import { pctSignFilter, percentageFilter } from "app/filters/ngFilters";
import { tiersConfig } from "app/common/keyword-research/keywords-overview/serpCompositionConsts";
import type { ITrafficShareBarProps } from "pro-features/styled components/StyledTrafficShare/src/StyledTrafficShare";

import type { ISerpTrafficDistributionItem, LowercaseKeys, SerpTrafficDistributionResponse } from "../types";

const { carbon } = colorsPalettes;

const textColorMap = {
    classicorganic: carbon[0],
    organicserpfeatures: carbon[0],
    pla: carbon[500],
    searchads: carbon[500],
} as const;

export const transformSerpTrafficDistributionResponse = (
    response: SerpTrafficDistributionResponse,
): ISerpTrafficDistributionItem[] => {
    const formattedResponse = Object.entries(response).reduce((acc, [key, value]) => {
        acc[key.toLowerCase()] = value;
        return acc;
    }, {} as LowercaseKeys<SerpTrafficDistributionResponse>);
    return tiersConfig.map(({ id, name, color }, idx) => {
        const formattedId = id.toLowerCase();
        const rawValue = formattedResponse[formattedId] as number;
        const value = rawValue ? pctSignFilter()(percentageFilter()(rawValue || 0, 1)) : NO_DATA_SIGN;
        return {
            id: formattedId,
            value,
            color,
            name,
            rawValue,
        };
    });
};

export const getTrafficDistributionBarConfigs = (data: ISerpTrafficDistributionItem[]): ITrafficShareBarProps[] => {
    return data
        .filter((dataItem) => dataItem.rawValue > 0)
        .map((dataItem) => {
            const { id, name, color, value, rawValue } = dataItem;
            return {
                name,
                color: textColorMap[id as keyof typeof textColorMap],
                width: !rawValue ? 0 : Math.round(rawValue * 100) || 1,
                backgroundColor: color,
                text: value,
            };
        });
};
